import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

import ButtonTypes from '../../constants/buttonTypes';

const Button = ({
  text, type, icon,
  iconRight, onClick, disabled,
  containerStyle, props, tooltip,
  tooltipId, tooltipDelayShow
}) => {
  const baseClasses = `
    flex items-center justify-center cursor-pointer h-max px-[20px] py-[11px] rounded-[6px]
    font-medium font-sans transition-all duration-300 ease-out relative
  `;
  const iconBase = 'flex items-center justify-center w-[20px] h-[20px]';
  const variantClasses = {
    [ButtonTypes.PRIMARY]: 'bg-primary text-white hover:bg-primary-hover',
    [ButtonTypes.WHITE]: `
      bg-white text-romanSilver hover:bg-whiteHover
      dark:bg-[#1b263b] dark:text-secondary dark:hover:bg-[#415a77]
    `,
    [ButtonTypes.LIGHT]: `
      bg-background-main text-romanSilver hover:bg-whiteHover
      dark:bg-[#1b263b] dark:text-secondary dark:hover:bg-[#415a77]
    `,
    [ButtonTypes.SECONDARY]: `
      bg-secondary text-text-main hover:bg-secondary-hover
      dark:bg-[#1b263b] dark:text-secondary dark:hover:bg-[#415a77]
    `,
    [ButtonTypes.SUCCESS]: 'bg-success text-white hover:bg-success-hover',
    [ButtonTypes.INFO]: 'bg-info text-white hover:bg-info-hover',
    [ButtonTypes.WARNING]: 'bg-warning text-white hover:bg-warning-hover',
    [ButtonTypes.DANGER]: 'bg-danger text-white hover:bg-danger-hover',
    [ButtonTypes.DARK]: 'bg-dark text-white hover:bg-danger-hover',
    [ButtonTypes.LIGHT_PRIMARY]: `
      bg-primary-light text-primary hover:bg-primary hover:text-white
      dark:bg-[#1b263b] dark:text-primary dark:hover:bg-[#415a77] dark:hover:text-white
    `,
    [ButtonTypes.LIGHT_INFO]: 'bg-info-light text-info hover:bg-info hover:text-white',
    [ButtonTypes.LIGHT_SUCCESS]: `
      bg-success-light text-success hover:bg-success hover:text-white
      dark:bg-[#1b263b] dark:text-[#e0e1dd] dark:hover:bg-[#415a77]
    `,
    [ButtonTypes.LIGHT_WARNING]: `
      bg-warning-light text-warning hover:bg-warning hover:text-white
      dark:bg-[#1b263b] dark:text-warning dark:hover:bg-[#415a77] dark:hover:text-white
    `,
    [ButtonTypes.LIGHT_DANGER]: 'bg-danger-light text-danger hover:bg-danger hover:text-white',
    [ButtonTypes.LIGHT_DARK]: 'bg-dark text-white hover:bg-dark-hover',
    [ButtonTypes.ACTIVE_LIGHT]: `
      bg-background-main text-primary font-normal hover:bg-whiteHover
      dark:bg-[#1b263b] dark:text-[#e0e1dd] dark:hover:bg-[#415a77]
    `
  };

  return (
    <>
      <div
        data-tip=""
        data-for={tooltipId}
        onClick={disabled ? () => {} : onClick}
        role="presentation"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        className={`
          ${baseClasses}
          ${variantClasses[type || ButtonTypes.PRIMARY] || variantClasses[ButtonTypes.PRIMARY]}
          ${disabled ? 'opacity-50' : ''}
          ${containerStyle || ''}
        `}
      >
        {icon && (
          <div className={`${iconBase} ${text ? 'mr-[8px]' : ''}`}>
            {icon}
          </div>
        )}
        {text}
        {iconRight && (
          <div className={`${iconBase} ${text ? 'ml-[8px]' : ''}`}>
            {iconRight}
          </div>
        )}
      </div>
      {tooltip
        && (
        <ReactTooltip
          id={tooltipId}
          place="top"
          effect="solid"
          delayShow={tooltipDelayShow}
        >
          {tooltip}
        </ReactTooltip>
        )}
    </>
  );
};

Button.propTypes = {
  text: PropTypes.string,
  type: PropTypes.string,
  tooltip: PropTypes.string,
  tooltipId: PropTypes.string,
  containerStyle: PropTypes.string,
  icon: PropTypes.shape({}),
  props: PropTypes.shape({}),
  iconRight: PropTypes.shape({}),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  tooltipDelayShow: PropTypes.number
};

Button.defaultProps = {
  text: undefined,
  tooltip: undefined,
  tooltipId: undefined,
  containerStyle: undefined,
  type: null,
  icon: undefined,
  props: undefined,
  iconRight: undefined,
  onClick: () => {},
  disabled: false,
  tooltipDelayShow: 1000
};

export default Button;
